import { Link, useHistory, useParams } from 'react-router-dom';
import {
	Button,
	Divider,
	Flex,
	FormControl,
	FormLabel,
	Grid,
	HStack,
	Skeleton,
	Spinner,
	Text,
	useColorModeValue
} from '@chakra-ui/react';

import { useReport } from 'hooks/customReports';

import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import CardHeader from 'components/Card/CardHeader';

const ViewReport = () => {
	const { id } = useParams();
	const { data, loading } = useReport(id);
	const report = data?.getReport || {};

	const history = useHistory();

	const textColor = useColorModeValue('gray.700', 'white');

	return (
		<Flex
			direction="column"
			minH="100vh"
			align="center"
			pt={{ sm: '120px', lg: '160px' }}
		>
			<Card w={{ md: '100%', lg: '50%' }}>
				<CardHeader mb="40px">
					<Flex direction="row" w="100%" justify="space-between">
						<Text
							color={textColor}
							fontSize="lg"
							fontWeight="bold"
							mb="3px"
						>
							Relatório
						</Text>
						<Flex>
							<HStack spacing={4} alignItems="flex-start">
								<Link to={`${id}/editar`}>
									<Button colorScheme="green" size="md">
										Editar
									</Button>
								</Link>
								<Button
									variant="ghost"
									colorScheme="gray"
									size="md"
									onClick={() => history.goBack()}
								>
									Voltar
								</Button>
							</HStack>
						</Flex>
					</Flex>
				</CardHeader>
				<CardBody>
					<Flex direction="column" w="100%">
						<Grid
							w="full"
							templateColumns={{
								sm: '1fr',
								md: 'repeat(1, 1fr)'
							}}
							gap="24px"
							mt="24px"
						>
							<FormControl>
								<FormLabel
									color={textColor}
									fontWeight="bold"
									fontSize="xs"
								>
									Nome
								</FormLabel>
								<Skeleton height="25px" isLoaded={!loading}>
									<Text
										color={textColor}
										fontSize="lg"
										fontWeight="bold"
										mb="3px"
									>
										{report.name}
									</Text>
								</Skeleton>
							</FormControl>
							{loading ? (
								<Flex w="full" justifyContent="center">
									<Spinner size="md" />
								</Flex>
							) : (
								report.columns.map((column, x) => (
									<>
										<HStack key={column.id}>
											<Text>
												{`#  ${column.label} - ${column.value}`}
											</Text>
										</HStack>
										{x + 1 !== report?.columns?.length && (
											<Divider />
										)}
									</>
								))
							)}
						</Grid>
					</Flex>
				</CardBody>
			</Card>
		</Flex>
	);
};

export default ViewReport;
